import { reduxForm } from 'redux-form';
import { connect } from 'react-redux'
import { signinUser } from '../../actions/auth_actions';

import Login from '../../components/Auth/login'

function mapStateToProps(state) {
    return { errorMessage: state.auth.error }
}

let LoginForm = reduxForm({
    form: 'signin'
})(Login);

LoginForm = connect(mapStateToProps, { signinUser })(LoginForm)

export default LoginForm



// WEBPACK FOOTER //
// ./master/jsx/containers/Auth/login.jsx